module.exports = __webpack_public_path__ + "static/media/Ennoia-Game-logo-color.72b44684.png";